import {Suspense, useContext, useEffect, useRef} from 'react'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import { useMutation } from 'react-query'
import PrivateRoute from 'components/PrivateRoute'
import PublicRoute from 'components/PublicRoute'
import GoogleTagManager from 'components/GoogleTagManager'
import Layout from 'components/Layout/Layout'
import Loading from 'components/Loading'
import {AuthContext} from 'contexts/AuthContext'
import { getUserProfile } from 'api'
import routes from 'utils/routes'
import {getItemFromStorage} from 'utils/storage'

function App() {
  const {state, dispatch} = useContext(AuthContext)
  const user = useRef(getItemFromStorage({name: 'user'}))
  const pollingIntervalRef = useRef(null)

  const { mutate: handleGetProfile } = useMutation(
    'getUserProfile',
    getUserProfile,
    {
      onSuccess: (data) => {
        dispatch({ ...state, isAuth: true, user: data })
      },
      onError: () => {
        console.error('Failed to fetch profile during polling')
      },
    }
  )

  useEffect(() => {
    const isAuth = user?.current ? true : false
    dispatch({...state, isAuth, user: user?.current})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const token = state?.user?.token
    if (token) {
      //get profile fn
    }
  }, [state])

  useEffect(() => {
    const userId =
      state?.user?.data?._id ||
      state?.user?._id ||
      getItemFromStorage({ name: 'user' })?._id

    if (state?.isAuth && userId) {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current)
      }

      handleGetProfile(userId)

      pollingIntervalRef.current = setInterval(() => {
        handleGetProfile(userId)
      }, 10 * 60 * 1000)

      return () => {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current)
          pollingIntervalRef.current = null
        }
      }
    } else {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current)
        pollingIntervalRef.current = null
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.isAuth, state?.user?.data?._id, state?.user?._id])

  return (
    <div className="App font-inter">
      <BrowserRouter>
        <GoogleTagManager />
        <div className="app-content">
          <Routes>
            {routes?.map((route, i) => {
              const key = `route-${i}`
              if (route.protected) {
                return (
                  <Route
                    key={key}
                    path={route.path}
                    element={
                      <PrivateRoute
                        isAuth={state?.isAuth}
                        path={route.path}
                        protect={route.protected}
                      >
                        <Layout>
                          <Suspense fallback={<Loading />}>
                            <route.component />
                          </Suspense>
                        </Layout>
                      </PrivateRoute>
                    }
                  />
                )
              } else {
                return (
                  <Route
                    key={key}
                    path={route.path}
                    element={
                      <PublicRoute path={route.path} isAuth={state?.isAuth}>
                        <Suspense fallback={<Loading />}>
                          <route.component />
                        </Suspense>
                      </PublicRoute>
                    }
                  />
                )
              }
            })}
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  )
}

export default App
